// extracted by mini-css-extract-plugin
export default {"checkWrap":"DeleteMessages_checkWrap_wdN0l"};